module.exports = __webpack_public_path__ + "media/images/home/top_banner-052801890c74ddf5076ca42550af5e9f.jpg";